<!--
 * @Descripttion: 
 * @version: 
 * @Author: tina.cai
 * @Date: 2023-05-20 15:22:38
 * @LastEditors: tina.cai
 * @LastEditTime: 2024-08-04 16:33:51
-->
<template>
  <div class="search-input search-input-c">
    <a-input
      v-model="inputValue"
      :placeholder="$t('search')"
      @change="handleSearch"
      :allowClear="true"
    >
      <template #suffix>
        <a-icon type="search" />
      </template>
    </a-input>
  </div>

</template>

<script>
import { debounce } from 'lodash'

export default {
  props: {
    searchVal: {
      type: String,
      required: true
    },
    clear: {
      type: Function,
      required: true
    }
  },
  watch: {
    value(newValue) {
      this.inputValue = newValue;
    }
  },
  data() {
    return {
      inputValue: this.searchVal
    }
  },
  methods: {
    handleSearch: debounce(function() {
      // 在这里处理搜索逻辑
      // console.log('搜索内容：', this.inputValue)
      // 触发 onsearch 事件
      this.$emit('onsearch', this.inputValue)
    }, 500),
    clearValue() {
      this.inputValue = '';
      this.clear();
    }
  }
}
</script>

<style lang="scss" scoped>
.search-input {
  display: flex;
  width: 100%;
}
</style>


<style lang="scss" >
.search-input-c {
  .ant-input-affix-wrapper .ant-input {
    border: 1px solid #a9a9a9;
    height: 50px;
    border-radius: 25px;
    padding-left: 28px;
    font-size: 20px;
    background: #fff;

  }
  .ant-input-affix-wrapper .ant-input-prefix, .ant-input-affix-wrapper .ant-input-suffix {
    color: rgba(0, 0, 0, .8);
    font-size: 20px;
  }
  .ant-input-affix-wrapper .ant-input {
    color: #000;

  }
  .ant-input-affix-wrapper .ant-input:focus {
    border: 2px solid #C100FF;
  }
  .ant-input-affix-wrapper:hover .ant-input:not(.ant-input-disabled) {
    border: 2px solid #C100FF;
  }
  .ant-input-clear-icon {
    color: rgba(0, 0, 0, .8);
    &:hover{
      color: rgba(0, 0, 0, 1);
    }
  }
}
.mobile {
  .search-input {
    .ant-input-affix-wrapper .ant-input {
      font-size: px2rem(24);
      height: px2rem(70);
    }
  }
}
</style>